import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PaymentConfirmService } from '../payment-confirm.service';
import { PaymentConfirm } from '../payment-confirm';

@Component({
    selector: 'app-payment-confirm',
    templateUrl: './payment-confirm.component.html',
    styleUrls: ['./payment-confirm.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PaymentConfirmComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private paymentConfirmService: PaymentConfirmService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.paymentConfirm = data.paymentConfirm,
			this.statuses = paymentConfirmService.statuses;
	}

	@Input() paymentConfirm: PaymentConfirm;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	paymentConfirmId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'paymentConfirmId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'paymentConfirmDate': [],
		'isPaymentConfirm': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole paymentConfirm object
		if (this.paymentConfirm) {
			this.paymentConfirmId = this.paymentConfirm.paymentConfirmId;
			this.fixDates();
			this.form1.patchValue(this.paymentConfirm);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.paymentConfirmId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		// Guard: prevent duplicate POSTs when the server is slow or returns 504
		if (this.formLoading) { return; }
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.paymentConfirmService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.paymentConfirm = res.data.paymentConfirm;
						this.doAdd.emit(this.paymentConfirm);
					},
					(err: any) => {
						console.log('paymentConfirm-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		// Guard: prevent duplicate PATCHes when the server is slow or returns 504
		if (this.formLoading) { return; }
		console.log('paymentConfirm: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.paymentConfirmService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.paymentConfirm = res.data.paymentConfirm;
						this.doUpdate.emit(this.paymentConfirm);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.paymentConfirmService.delete(this.paymentConfirm.paymentConfirmId)
				.subscribe(
					(res: any) => {
						console.log('paymentConfirm-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.paymentConfirm);
					},
					(err: any) => {
						console.log('paymentConfirm-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			paymentConfirmId: [this.paymentConfirmId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: [],
			paymentConfirmDate: [],
			isPaymentConfirm: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.paymentConfirm.paymentConfirmDate = moment(this.paymentConfirm.paymentConfirmDate).toDate();
	}
}
